import styled from 'styled-components'

export const PaymentContainer = styled.div`
    border-radius: 1rem;
    position: relative;

    min-height: 20rem;
    margin-top: 2rem;

    color: #000000;
    font-size: 2.4rem;
    font-style: normal;
    font-weight: normal;
    line-height: 100%;

    .link-wrap {
        margin: 0.5rem 0 2.4rem;
        text-align: left;

        a {
            text-decoration: none;
            color: rgba(239, 68, 68, 1);
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
        }
    }

    &.otp-wrapper {
        .error-display-wrapper {
            justify-content: center;
        }
    }
    
    div > .input-wrapper > div {
        border-radius: 16px;
        background-color: #ff0431;

        :has(div > div[id^='react-select'][id$='listbox']) {
            border-radius: 16px 16px 0 0;
        }

        div > div[id^='react-select'][id$='listbox'] {
            border: none;
            box-shadow: none;
            left: -20px;
            width: 398px;
            overflow: hidden;
            border-radius: 0 0 12px 12px;
        }
    }

    .lower-input-section {
        display: flex;
        flex-flow: row nowrap;

        .input-wrapper {
            .left-icon {
                padding-left: 3.5rem;
            }

            &:last-of-type {
                border-left: 1px solid rgba(238, 238, 238, 1);

                .input-inner-wrapper {
                    padding: 0 1rem;
                }
            }
        }
    }

    .input-wrapper {
        width: auto;
        margin-left: 0;
        margin-right: 0;
    }

    .otp-title {
        color: #000000;
        font-size: 1.8rem;
        font-style: normal;
        font-weight: 400;
        line-height: 2.2rem;
        text-align: center;
    }

    .otp-subtitle {
        color: #000000;
        font-size: 1.4rem;
        font-style: normal;
        font-weight: 400;
        line-height: 2.2rem;

        text-align: center;
        margin-top: 2rem;
        margin-bottom: 2rem;

        span {
            display: block;
            font-weight: 700;
            overflow-wrap: anywhere;
        }
    }

    #otp {
        font-size: 1.8rem;
        font-style: normal;
        font-weight: 600;
        line-height: 2.2rem;
        letter-spacing: 1.2rem;

        text-align: center;

        width: 20rem;
        margin: 0 auto;
        padding-bottom: 1rem;

        border: none;
        border-bottom: 1px solid #eeeeee;
        background-color: #ffffff;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &:focus {
            outline: none;
        }

        &::-webkit-input-placeholder {
            color: #dadada;
            font-family: Inter, sans-serif;
            font-size: 1.8rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2.2rem;
            letter-spacing: normal;
        }

        &:-ms-input-placeholder {
            color: #dadada;
            font-family: Inter, sans-serif;
            font-size: 1.8rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2.2rem;
            letter-spacing: normal;
        }

        &::placeholder {
            color: #dadada;
            font-family: Inter, sans-serif;
            font-size: 1.8rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2.2rem;
            letter-spacing: normal;
        }

        &.wrong {
            border-color: #ff0431;
        }
    }

    .account-title {
        margin-bottom: 3rem;
    }

    button {
        font-size: 1.8rem;
        font-weight: 600;
        line-height: 2.2rem;

        margin-bottom: 0.8rem;

        :last-of-type {
            margin-bottom: 0;
        }
    }
`

export const SignupLinkWrapper = styled.div`
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  color: rgba(43, 49, 58, 1);
  padding: 2rem;

  font-size: 1.3rem;
  font-style: normal;
  font-weight: 400;
  line-height: 102.52%;
  letter-spacing: -0.025em;

  position: relative;

  a {
    color: rgba(239, 68, 68, 1);

    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.6rem;
    text-decoration: none;
    outline: none;

    display: flex;
    align-items: center;
    text-align: center;
    margin-left: 1em;
    span {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .arrow {
      font-size: 2rem;
    }
  }
`

export const OtpResendMessage = styled.div`
  color: #000000;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.7rem;
  text-align: center;

  margin-top: 2rem;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 0.5rem;
    display: block;
    text-decoration: none;
    cursor: pointer;
    color: rgba(239, 68, 68, 1);
    &:hover {
      text-decoration: underline;
    }
  }
`
